module.exports = __webpack_public_path__ + "static/fowf-advisor-3-7667f3f093abad390fee70c57bd0aef8.jpg";